export default __webpack_public_path__ + "static/media/tolet1.27fa4190.jpeg";